import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//MatrikelMoreHandler
import { Class } from "../../utils";
import DetailsHandlerDef from "../../details/DetailsHandlerDef";
export default Class(DetailsHandlerDef, {
  initialize: function initialize(options) {
    var isMore = true;
    if (typeof options !== 'undefined') if (typeof options.more !== 'undefined') isMore = options.more;
    var myOptions = {
      buttonText: "Matrikel-info",
      handler: this.myHandler,
      isApplicable: function isApplicable(result) {
        return result.source === "Kortforsyningen" && result.type === "Matrikelnumre";
      },
      more: isMore
    };
    DetailsHandlerDef.prototype.initialize.apply(this, [myOptions]);
  },
  myHandler: function () {
    var _myHandler = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(result) {
      var items;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              items = [];
              items.push({
                type: "area",
                label: "ESR-nummer",
                value: result.data.esrejdnr
              });
              items.push({
                type: "area",
                label: "SFE-nummer",
                value: result.data.sfeejdnr
              });
              return _context.abrupt("return", items);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function myHandler(_x) {
      return _myHandler.apply(this, arguments);
    }

    return myHandler;
  }(),
  CLASS_NAME: 'Septima.Search.MatrikelInfoHandler'
});